<template>


  <v-card
      style="position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        z-index: 100000;
        display: flex;
        justify-content: center;
        align-items: center;"
      v-if="error_text !== null"
  >

    <v-card flat max-width="450px" style="flex: 1 1 auto; display: flex;  justify-content: center; align-items: center; flex-direction: column;">

      <v-icon size="80" class="mt-5">{{ icon }}</v-icon>

      <div class="pa-3 text-h6 text-center">
        {{ text }}
      </div>

      <v-card-actions v-if="$slots.actions" class="d-flex align-center justify-center">
        <slot name="actions"></slot>
      </v-card-actions>

    </v-card>

  </v-card>

</template>


<script>

export default {
  name: 'globalError',
  props: {
    text: {required: true, type: String},
    icon: {required: false, type: String, default: 'mdi-alert'},
  }
}

</script>